import { render, staticRenderFns } from "./WallteBalance.vue?vue&type=template&id=1bfe641c&"
import script from "./WallteBalance.vue?vue&type=script&lang=js&"
export * from "./WallteBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports